import { render, staticRenderFns } from "./SamlMapping.vue?vue&type=template&id=148ef14b&scoped=true"
import script from "./SamlMapping.vue?vue&type=script&lang=js"
export * from "./SamlMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148ef14b",
  null
  
)

export default component.exports